import React from 'react';

import { Stack } from '../stack';
import { Card } from '../card';
import { Text } from '../text';
import { Image } from '../img';
import { Element } from '../../primitives';
import { TickIcon } from '../../icons';
import { Dialog } from '../dialog';
import { merge } from '../../utils';

const AddedToListText = ({ css }) => {
  return (
    <Element
      css={merge(
        {
          width: '280px',
          height: '40px',
          margin: 'auto',
          marginTop: '25px',
          color: 'primary',
          textAlign: 'center',
          border: '2px solid',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        css
      )}
    >
      <Element as="span" style={{ marginRight: '5px', height: '100%', lineHeight: 'adjustFontHeight' }}>
        ADDED TO LIST
      </Element>
      <TickIcon />
    </Element>
  );
};

const DialogPodView = ({ offer, activeButtonCss }) => {
  if (!offer) return null;

  return (
    <Card margin={3} css={{ border: 'none' }} variant="list">
      <Stack direction={['horizontal']} gap={[0, 10]} align="center">
        <Stack direction="vertical" gap={[8, 6]} css={{ flexBasis: ['100%', '50%'] }}>
          <Text size={6} weight="bold">
            {offer.offerSummary}
          </Text>
          <Stack
            direction={['vertical']}
            css={{
              alignSelf: ['center', 'start'],
              display: ['flex', 'none'],
              height: ['215px', 'auto'],
              marginBottom: '40px'
            }}
            align="center"
          >
            <Image css={{ width: ['170px', 'auto'] }} src={offer.largeImage || offer.offerImage} alt="Offer image" />
            <Text weight="bold" size={3}>
              Exp. {offer.offerExpiryDateFormatted}
            </Text>
          </Stack>
          <Text color="grays.600" css={{ wordBreak: 'break-word' }} size={2}>
            {offer.offerDescription}
          </Text>
          <Text color="grays.600" css={{ wordBreak: 'break-word' }} size={2}>
            <Text color="grays.600" size={2} weight="bold" marginRight="1ch">
              Details:
            </Text>
            {offer.offerDisclaimer}
          </Text>
        </Stack>
        <Stack direction={['vertical']} align="center" css={{ alignSelf: 'start', display: ['none', 'flex'] }}>
          <Image src={offer.largeImage || offer.offerImage} alt="Offer image" style={{ maxWidth: '80px' }} />
          <Text weight="bold" size={3}>
            {' '}
            Exp. {offer.offerExpiryDateFormatted}
          </Text>
        </Stack>
      </Stack>
      <AddedToListText css={activeButtonCss} />
    </Card>
  );
};

const DetailDialogPod = ({ isOpen = false, closeFn, data, closeIcon, activeButtonCss }) => {
  return (
    <Dialog isOpen={isOpen} onDismiss={closeFn} aria-label="modal" closeIcon={closeIcon}>
      <DialogPodView offer={data?.offer} activeButtonCss={activeButtonCss} />
    </Dialog>
  );
};

export { DetailDialogPod };
